var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rightbar"},[_c('ul',_vm._l((_vm.floatList),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":_vm.$common.getImgUrl(item.floatingPic)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }